import React from "react";
import { Box, Typography } from "@mui/material";
import Breadcrumbs from "../../common/Breadcrumbs";
import Grid from "@mui/material/Grid2";
import {
  contactData,
  FAQSData,
  KeySpecifications,
} from "../../constants/helpAndSupport";
import ContactTable from "./ContactTable";
import ContentSection from "./ContentSection";

const HelpAndSupport: React.FC = () => (
  <>
    <Breadcrumbs
      paths={["Home", "Support"]}
      links={["/customer/home", "/customer/help-support"]}
    />
    <Box
      sx={{
        padding: { xs: "16px 16px", sm: "0 28px 45px 28px" },
        background: "#FFFFFF",
        boxShadow: { xs: "none", sm: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)" },
      }}
    >
      <Typography
        variant="h5"
        paddingY="25px"
        fontFamily="Roboto"
        fontWeight="700"
        fontSize={{ xs: "14px", sm: "24px" }}
      >
        Hello, how can we help you?
      </Typography>
      <Grid container>
        <Grid size={{ xs: 12, sm: 10 }}>
          <ContactTable data={contactData} />
        </Grid>
      </Grid>
      <Grid pt="50px">
        <Grid size={{ xs: 12, sm: 10 }}>
          <Typography
            variant="h4"
            sx={{
              marginBottom: "20px",
              fontWeight: "700",
              fontSize: { md: "32px", xs: "18px" },
            }}
          >
            {/* &lsquo; for a left single quotation mark (opening apostrophe) */}
            FAQ&lsquo;s
          </Typography>
          <ContentSection
            title="Keg Ordering, Delivery & Payment Process"
            data={FAQSData}
          />
        </Grid>
      </Grid>
      <Grid mt={{ xs: "40px", sm: "120px" }}>
        <Grid size={{ xs: 12, sm: 10 }}>
          <ContentSection
            title="Keg Specifications & Storage"
            data={KeySpecifications}
          />
        </Grid>
      </Grid>
      <Box
        sx={{
          backgroundColor: " #EFEDE0",
          margin: "84px 0px 20px 0px",
          padding: "20px",
          borderRadius: "17px",
        }}
      >
        <Typography
          sx={{
            fontSize: "15px",
            fontWeight: "500",
            fontFamily: "Poppins",
            color: "#53686A",
          }}
        >
          Still have questions?
        </Typography>
        <Typography
          sx={{
            fontSize: "13px",
            fontWeight: "400",
            fontFamily: "Poppins",
            color: "#53686A",
          }}
        >
          Can’t find the answer you’re looking for? Please get in touch with us
          on{" "}
          <Typography
            component="span"
            sx={{ fontWeight: "700", fontSize: "13px", color: "#252525" }}
          >
            +91-9036025879
          </Typography>
        </Typography>
      </Box>
    </Box>
  </>
);

export default HelpAndSupport;
